import http from './httpClient';

class RoleService {
  static async listRoles(businessId) {
    const data = await http.get(`/roles?business_id=${businessId}`);
    if (!data.success) throw new Error(data.error || 'Failed to fetch roles');
    return data;
  }

  static async getRolePermissions(roleId) {
    const data = await http.get(`/roles/${roleId}/permissions`);
    if (!data.success) throw new Error(data.error || 'Failed to fetch role permissions');
    return data;
  }

  static async getAllPermissions() {
    const data = await http.get('/role-permissions/all');
    if (!data.success) throw new Error(data.error || 'Failed to fetch all permissions');
    return data;
  }

  static async updateRolePermissions(roleId, permissionIds) {
    const data = await http.post('/role-permissions/update', {
      roleId,
      permissions: permissionIds
    });
    if (!data.success) throw new Error(data.error || 'Failed to update permissions');
    return data;
  }

  /**
   * Toggle a single permission ON/OFF for a role
   * @param {number} roleId - Role ID
   * @param {number} permissionId - Permission ID
   * @param {boolean} accessStatus - TRUE to enable, FALSE to disable
   */
  static async togglePermission(roleId, permissionId, accessStatus) {
    const data = await http.post('/role-permissions/toggle', {
      roleId,
      permissionId,
      accessStatus
    });
    if (!data.success) throw new Error(data.error || 'Failed to toggle permission');
    return data;
  }

  /**
   * Get audit log of permission changes (Owner only)
   * @param {number} businessId - Business ID
   * @param {object} filters - Optional filters { userId, actionType, startDate, endDate }
   */
  static async getAuditLogs(businessId, filters = {}) {
    const params = new URLSearchParams({ business_id: businessId, ...filters });
    const data = await http.get(`/role-permissions/audit-logs?${params}`);
    if (!data.success) throw new Error(data.error || 'Failed to fetch audit logs');
    return data;
  }
}

export default RoleService;
